<template>
  <div class="main-body">
    <div class="header">
      护理类型
    </div>
    <div class="out">

      <div class="search2">

          <el-button size="mini" type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
          <el-button size="mini" type="success" :disabled="disabledEdit" @click="handleEdit">编辑</el-button>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="sort" label="排序"></el-table-column>

        <el-table-column
            prop="status"
            :formatter="statusTitle"
            label="状态">
        </el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      loading:false,
      showModalAdd:false,
      showModalEdit:false,
      menuButtonList:null,
      disabledAdd:false,
      disabledEdit:true,
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      row:null,
      th:0

    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.getList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    rowClick(row){
      this.row=row;
      //if(this.menuButtonList.indexOf("编辑")!=-1){
        this.disabledEdit =false;
      //}

    },
    handleEdit() {
      this.$refs.myEdit.init(this.row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingType/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;
        this.disabledEdit = true;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },



  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}
</style>
